import type { Form, UiDaten } from "./modell.ts";

export function slotAnzahl(form: Form): number {
  switch (form.art) {
    case "truhe":
      return form.reihen * 9;
    case "trichter":
      return 5;
    case "spender":
      return 9;
  }
}

export function spalten(form: Form): number {
  switch (form.art) {
    case "truhe":
      return 9;
    case "trichter":
      return 5;
    case "spender":
      return 3;
  }
}

export function blaetterSlots(ui: UiDaten): number[] {
  return ui.listen.flatMap((l) => [l.blaettern?.zurueck, l.blaettern?.weiter, l.blaettern?.info].filter((b) => b !== undefined).map((b) => b.slot));
}

/** Alle belegten Positionen, die bei der neuen Form wegfallen würden. */
export function ausserhalb(ui: UiDaten, form: Form): number[] {
  const n = slotAnzahl(form);
  const alle = [...Object.keys(ui.slots).map(Number), ...ui.listen.flatMap((l) => l.slots), ...blaetterSlots(ui)];
  return [...new Set(alle.filter((i) => i >= n))].sort((a, b) => a - b);
}
